module.exports = __webpack_public_path__ + "static/media/brick-wall.0147b8bd.svg";